export const punishmentFields = (roleOptions: { label: string; value: string }[]) => [
  {
    name: 'org_chart_node_id',
    label: 'Role',
    type: 'select',
    required: true,
    options: roleOptions,
    placeholder: 'Select role',
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    placeholder: 'Enter punishment name',
  },
  {
    name: 'value',
    label: 'Punishment',
    type: 'text',
    required: true,
    placeholder: 'Enter punishment value',
    colSpan: 2,
  },
  {
    name: 'description',
    label: 'Description',
    type: 'richtext',
    placeholder: 'Enter description',
    colSpan: 2,
  },
  {
    name: 'attachment_file',
    label: 'File Attachment',
    type: 'upload',
    uploadType: 'both' as const,
    colSpan: 2,
  },
];
